import {DRAWER} from "./drawer";
import {U, __, short_popup} from "./global";

export const RATINGFORM = {
    form_counter: 1,
    grecaptcha_loaded: false,
    init_captcha: function(container) {
        if (container.find('.captcha').length > 0) {
            if (!this.grecaptcha_loaded)
                jQuery.getScript("//www.google.com/recaptcha/api.js")
                    .done((script, textStatus) => {
                        this.grecaptcha_loaded = true;
                        this.render_captcha(container);
                    });
            else
                this.render_captcha(container);
        }
    },

    render_captcha: function(container) {
        container.find('.captcha').attr('id', 'rcptch' + this.form_counter);
        this.form_counter++;

        setTimeout(function(){
            if (typeof grecaptcha !== "undefined") {
                let widgetId = grecaptcha.render(container.find('.captcha')[0], {
                    'sitekey' : container.data('key')
                });

                container.find('.captcha').attr('data-widget-id', widgetId)
            }
        }, 500);
    },

    active_submit: function(container) {
        setTimeout(() => {
            if (this.show_errors(container, false))
                container.find('[type=submit]').removeClass('active');
            else {
                this.init_captcha(container);
                container.find('[type=submit]').addClass('active');
            }
        }, 0);
    },

    show_errors: function(container, show) {
        let errors = 0;

        if (container.find('[name=rating]').length > 0) {
            let check = container.find('[name=obj_type]').val()=='6' ? false : true;
            if (check) {
                if (container.find('[name=rating]').val() == 0) {
                    if (show)
                        container.find('.for-rating label span').removeClass('hidden');

                    errors++;
                } else {
                    if (show)
                        container.find('.for-rating label span').addClass('hidden');
                }
            }
        }

        if ($.trim(container.find('[name=comment]').val()).length < 10) {
            if (show)
                container.find('[name=comment]').parent().find('label span').removeClass('hidden');
            errors++;
        } else {
            if (show)
                container.find('[name=comment]').parent().find('label span').addClass('hidden');
        }

        if (container.find('[name=name]').length > 0) {
            const name = $.trim(container.find('[name=name]').val());
            if (name.length < 2) {
                if (show)
                    container.find('[name=name]').parent().find('label span').removeClass('hidden');

                errors++;
            } else {
                if (show)
                    container.find('[name=name]').parent().find('label span').addClass('hidden');
            }
        }

        return errors;
    },

    highlight: function(id) {
        console.log(`.review[data-id=${id}]`);
        $(`.review[data-id=${id}]`).addClass('review-highlighted');
    },

    submit: function(container) {
        let data = container.serializeObject();
        let error = '';
        let response = '';
        const submit = container.find('[type=submit]');

        container.find('.js-alert-error, .js-alert-success').addClass('hidden')

        if (submit.hasClass('loading')) {
            return;
        }

        if (container.find('.captcha').length > 0) {
            let el = container.find('.captcha');
            if (!(typeof grecaptcha === "undefined")) {
                response = grecaptcha.getResponse(el.attr('data-widget-id'));

                if (response.length == 0)
                    error = __('Підтвердіть, що Ви не робот');
            } else {
                error = __('Потрібно підтвердити, що Ви не бот, за допомогою Recaptcha.');
            }
        }

        if (error=='') {
            submit.addClass('loading');
            data.gresponse = response;
            console.log(data);

            U.postData(
                data,
                '/comments/add'
            ).then(result => {
                if (result.success) {
                    container.find('.js-alert-error').addClass('hidden');
                    data.parent_id = parseInt(data.parent_id);

                    const message = '<b>Дякуємо!</b> Після перевірки модератором сайту Ваш відгук з\'явиться на сайті. Гарного дня!';

                    switch(container.data('form_type')) {
                        case 'product_firstpage':
                            container.trigger('reset');

                            if (result.approved) {
                                $(".product__block.short-test").html(`
                                    <strong>Дякуємо!</strong> Коментар додано. <a href="#" class="typical typical-large js-go-tabproduct" data-tab="comments">Перейти до коментарів</a>
                                `);

                                this.load_comments(data.obj_id, data.obj_type, '.js-commentslist', {
                                    type: data.type
                                }).then(() => {
                                    this.highlight(result.comment_id);
                                });
                            } else {
                                $(".product__block.short-test").html(`
                                    <div class="js-alert-success">
                                        ${message}
                                    </div>
                                `);
                            }

                            break;

                        case 'product_comments':
                            container.trigger('reset');

                            if (result.approved) {
                                $(".product__tab-comments .js-write-review").removeClass('hidden');
                                container.remove();

                                this.load_comments(data.obj_id, data.obj_type, '.js-commentslist', {
                                    type: data.type
                                }).then(() => {
                                    this.highlight(result.comment_id);
                                });
                            } else {
                                if (data.parent_id > 0) {
                                    const error_button = container.find('.js-alert-success');
                                    error_button.removeClass('hidden').html(message);
                                    container.replaceWith(error_button);
                                } else {
                                    const have_another_comments = $(".product__tab-comments .review").length > 0;
                                    const alert_message = `<div class="alert alert-success js-alert-success">${message}</div>`;

                                    if (have_another_comments) {
                                        container.find('.js-alert-success').addClass('hidden');
                                        $(".js-commentslist .product__tabinnerinside").prepend(alert_message);
                                    } else {
                                        // цей шмат лайна андрій попросив зробити
                                        $(".js-commentslist").html(`
                                            <div class="product__tabinner reviews-full">
                                                <div class="product__tabinnerinside">
                                                    ${alert_message}
                                                </div>
                                            </div>
                                        `);
                                    }

                                    $(".product__tab-comments .js-write-review").removeClass('hidden');
                                    container.remove();
                                }
                            }

                            break;

                        case 'product_questions':
                            container.trigger('reset');

                            if (result.approved) {
                                $(".product__tab-questions .write-question").removeClass('hidden');
                                container.remove();

                                this.load_comments(data.obj_id, data.obj_type, '.js-questionslist', {
                                    type: data.type
                                }).then(() => {
                                    this.highlight(result.comment_id);
                                });
                            } else {
                                if (data.parent_id > 0) {
                                    const error_button = container.find('.js-alert-success');
                                    error_button.removeClass('hidden').html(message);
                                    container.replaceWith(error_button);
                                } else {
                                    const have_another_comments = $(".product__tab-questions .review").length > 0;
                                    const alert_message = `<div class="alert alert-success js-alert-success">${message}</div>`;

                                    if (have_another_comments) {
                                        container.find('.js-alert-success').addClass('hidden');
                                        $(".js-questionslist .product__tabinnerinside").prepend(alert_message);
                                    } else {
                                        // цей шмат лайна андрій попросив зробити
                                        $(".js-questionslist").html(`
                                            <div class="product__tabinner reviews-full">
                                                <div class="product__tabinnerinside">
                                                    ${alert_message}
                                                </div>
                                            </div>
                                        `);
                                    }

                                    $(".product__tab-questions .js-write-review").removeClass('hidden');
                                    container.remove();
                                }
                            }

                            break;

                        case 'blog':
                            container.trigger('reset');

                            if (result.approved) {
                                $(".js-blog__comments .js-write-review").removeClass('hidden');
                                container.addClass('hidden');

                                this.load_comments(data.obj_id, data.obj_type, '.js-commentslist').then(() => {
                                    this.highlight(result.comment_id);
                                });
                            } else {
                                if (data.parent_id > 0) {
                                    const error_button = container.find('.js-alert-success');
                                    error_button.removeClass('hidden').html(`<b>Дякуємо!</b> Після перевірки модератором сайту Ваш відгук з'явиться на сайті. Гарного дня!`);
                                    container.replaceWith(error_button);
                                } else {
                                    const have_another_comments = $(".js-commentslist .review").length > 0;

                                    if (have_another_comments) {
                                        container.find('.js-alert-success').removeClass('hidden').html(`<b>Дякуємо!</b> Після перевірки модератором сайту Ваш відгук з'явиться на сайті. Гарного дня!`);
                                    } else {
                                        // цей шмат лайна андрій попросив зробити
                                        $(".js-commentslist").html(`
                                            <div class="comments__tabinner reviews-full">
                                                <div class="comments__tabinnerinside">
                                                    <div class="alert alert-success js-alert-success"><b>Дякуємо!</b> Після перевірки модератором сайту Ваш відгук з'явиться на сайті. Гарного дня!s</div>
                                                </div>
                                            </div>
                                        `);

                                        $(".js-blog__comments .js-write-review").removeClass('hidden');
                                        container.remove();
                                    }
                                }
                            }

                            break;

                    }
                } else {
                    container.find('.js-alert-error').removeClass('hidden').html(__('Помилки при підтвердженні капчі. Спробуйте ще раз.'));
                }
            }).catch(() => {
                container.find('.js-alert-error').removeClass('hidden').html('Помилки при додаванні коментаря. Спробуйте ще раз.');
            }).finally(() => {
                submit.removeClass('loading');
            });
        } else {
            container.find('.js-alert-error').html(error).removeClass('hidden');
            return;
        }
    },

    load_comments: function(obj_id, obj_type, element_to_replace = '', params = {})
    {
        return U.postData(
            {
                obj_id,
                obj_type,
                ...params
            },
            '/comments/list'
        ).then(data => {
            $(element_to_replace).html(data.html);
            $(element_to_replace).removeClass('hidden');
        });
    }
};

export function init_COMMENTS_events() {
    jQuery(document).ready(function () {

        jQuery("body").on('click', '.rating-input a', function (e) {
            e.preventDefault();

            const btn = $(this);
            const container = btn.parent();

            container.find('a').removeClass('active');
            container.find('input').val(btn.data('id'));

            let i = 0;
            for (i = 0; i < btn.index(); i++) {
                container.find('a:eq(' + i + ')').addClass('active');
            }

            container.parent().find('label span').addClass('hidden');
            RATINGFORM.active_submit(container.parents('.add-comment-form'));
        });

        jQuery("body").on('keyup', '.add-comment-form input[type=text], .add-comment-form textarea, .add-question-form input[type=text], .add-question-form textarea', function (e) {
            let input = $(this);
            let container = input.parent();
            container.find('label span').addClass('hidden');
            RATINGFORM.active_submit(input.parents('.add-comment-form, .add-question-form'));
        });

        jQuery("body").on('mouseover', '.rating-input a, .rates-votes a', function (e) {
            e.preventDefault();

            let btn = $(this);
            let container = btn.parent();

            container.find('a').removeClass('hover');

            let i = 0;
            for (i = 0; i < btn.index(); i++) {
                container.find('a:eq(' + i + ')').addClass('hover');
            }
        });

        jQuery("body").on('mouseout', '.rating-input a, .rates-votes a', function (e) {
            e.preventDefault();
            let btn = $(this);
            let container = btn.parent();
            container.find('a').removeClass('hover');
        });

        jQuery("body").on('click', '.rates-votes a', function (e) {
            e.preventDefault();

            let btn = $(this);
            let container = btn.parent();

            container.find('a').removeClass('active');
            btn.addClass('active');
        });

        jQuery("body").on('click', '.add-comment-form [type=submit], .add-question-form [type=submit]', function (e) {
            e.preventDefault();
            let btn = $(this);
            let container = btn.parents('.add-comment-form, .add-question-form');
            if (!RATINGFORM.show_errors(container, true))
                RATINGFORM.submit(container);
        });

        jQuery("body").on('paste change', '.add-comment-form [name=name]', function (e) {
            e.preventDefault();
            let input = $(this);

            let newval = '';

            if (e.type == "paste")
                newval = e.originalEvent.clipboardData.getData('text');

            if (e.type == "change")
                newval = input.val();

            newval = newval.replace(/[^а-яА-ЯЄєйЙїЇіІьЬ\s'\-]/gi, '');

            input.val($.trim(newval));

            if (!(typeof e.originalEvent === "undefined"))
                input.trigger('keyup');
        });

        jQuery("body").on('click', '.add-comment-form [type=button].cancel, .add-question-form [type=button].cancel', function (e) {
            e.preventDefault();
            let btn = $(this);
            let container = btn.parents('.add-comment-form, .add-question-form');
            container.remove();
            $(".product__tab >.write-review, .blog__comments >.write-review").removeClass('hidden');
        });

        jQuery("body").on('click', '.js-write-comment, .js-write-review', function (e) {
            e.preventDefault();
            const btn = $(this);

            setTimeout(() => {
                const form = $(".add-comment-form.origin").clone();

                $(".add-comment-form:not(.origin)").remove();
                form.removeClass('origin').removeClass('hidden').find('[name=parent_id]').val(btn.data('parent'));
                form.insertAfter(btn);

                if (btn.parent().hasClass('product__tab')) {
                    btn.addClass('hidden');
                    form.addClass('product__tabinner');
                }

                if (btn.parent().hasClass('blog__comments')) {
                    btn.addClass('hidden');
                    form.addClass('comments__tabinner');
                }
            }, 0);

        });

        jQuery("body").on('click', '.write-answer, .write-question', function (e) {
            e.preventDefault();
            let btn = $(this);
            $(".add-question-form:not(.origin)").remove();
            let form = $(".add-question-form.origin").clone();
            form.removeClass('origin').removeClass('hidden').find('[name=parent_id]').val(btn.data('parent'));
            form.insertAfter(btn);

            if (btn.parent().hasClass('product__tab')) {
                btn.addClass('hidden');
                form.addClass('product__tabinner');
            }

            if (btn.parent().hasClass('blog__comments')) {
                btn.addClass('hidden');
                form.addClass('comments__tabinner');
            }
        });

    });
}

init_COMMENTS_events();